import React from "react";

export default function SiteFooter({ visitor = 428391 }) {
  return (
    <div
      data-testid="site-footer"
      className="bevel-in px-3 py-2 text-[11px]"
      style={{
        background: "linear-gradient(to bottom, #003c9e, #0053e1)",
        color: "white",
      }}
    >
      <hr className="rainbow-hr mb-2" />
      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <div>
            <span className="font-bold">You are visitor #</span>
            <span className="font-mono text-[#FFEB3B]">{visitor.toLocaleString()}</span>
            <span className="mx-2 opacity-50">·</span>
            <span>Last updated: <span className="font-mono">02/18/2026</span></span>
          </div>
          <div className="text-[10px] opacity-80">
            &copy; 2003-2026 LemonWire Labs, Inc. &middot; lemonwire.fm &middot;
            All MP3s are the property of their respective awesome artists.
          </div>
          <div className="text-[10px] opacity-60 italic">
            This site does not condone piracy. It merely commemorates an era of it.
            No files were actually harmed in the making of this app.
          </div>
        </div>
        <div className="text-right space-y-0.5">
          <div className="text-[10px] opacity-80">
            Powered by <b className="text-[#FFEB3B]">LemonShield™ v4.2</b>
          </div>
          <div className="text-[10px] opacity-80">
            Made with <b className="text-[#FFEB3B]">Microsoft FrontPage 2002</b>*
          </div>
          <div className="text-[9px] opacity-50">*not actually, thank god</div>
        </div>
      </div>
    </div>
  );
}
